//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { useDisclosure } from "@chakra-ui/react";
import styled from "@emotion/styled";
import _ from "lodash";
import React from "react";
import { Icon } from "semantic-ui-react";
import { MenuTitleText } from "../../ui/lib";
import { CopyableId } from "../../util/CopyableId";
import { TopMenuResourceId } from "../TopMenuInfo";
import EditableTitleModal from "./EditableTitleModal";

const EditableMenuTitleText = styled(MenuTitleText)`
  .edit-icon {
    opacity: 0.01;
    animation: edit-icon-disappear;
    animation-duration: 4s;
  }
  &:hover {
    .edit-icon {
      opacity: 1;
    }
  }
  .resourceId {
    /* flex, not a text line: otherwise the 32px title font sizes the line box and the 12px ID sits ~25px below the name */
    display: flex;
    line-height: normal;
    color: var(--gray-600);
  }
  @keyframes edit-icon-disappear {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.01;
    }
  }
`;

const EditableTitle = ({
  title,
  subTitle,
  save,
  resourceId,
}: {
  title: string;
  subTitle: string;
  save?: (title: string, subTitle: string) => Promise<void>;
  resourceId?: TopMenuResourceId;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const canEdit = !!save;

  return (
    <EditableMenuTitleText onClick={canEdit ? onOpen : () => {}}>
      {!!save && isOpen && <EditableTitleModal title={title} subTitle={subTitle} onClose={onClose} onSave={save} />}
      {title} {canEdit && <Icon name="pencil" size="tiny" className="edit-icon" />}
      {resourceId && (
        <div className="resourceId">
          <CopyableId label={resourceId.label} value={resourceId.value} />
        </div>
      )}
      {!_.isEmpty(subTitle) && <div className="subTitle">{subTitle}</div>}
    </EditableMenuTitleText>
  );
};

export default EditableTitle;
